import {
  Component,
  InputSignal,
  inject,
  input,
  InputSignalWithTransform,
  booleanAttribute
} from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { Agreement, AgreementStatus, AgreementType } from '@tdwb/lazy/platform/preferences';
import {
  HrefDirective,
  IconComponent,
  LinkAccessibilityDirective,
  ModalService,
  SecurityService,
  TranslatePipe
} from '@tdwb/core';
import { ConsolidatedAgreementsModalComponent } from './consolidated-agreements.modal.component';
@Component({
  selector: 'td-wb-consolidated-agreements-list',
  templateUrl: 'consolidated-agreements-list.component.html',
  styleUrls: ['consolidated-agreements-list.component.scss'],
  imports: [
    HrefDirective,
    IconComponent,
    LinkAccessibilityDirective,
    TranslateDirective,
    TranslatePipe
  ]
})
export class ConsolidatedAgreementsListComponent {
  private readonly securityService = inject(SecurityService);
  private readonly modalService = inject(ModalService);
  private static readonly TERMS_CONDITION_TYPES: ReadonlyArray<AgreementType> =
    [AgreementType.TDW_TERMS_AND_CONDITIONS, AgreementType.TDW_TERMS_AND_CONDITIONS_LITE];

  protected readonly fplPermisson: boolean = this.securityService.hasPermission('FULLY_PAID_LENDING');
  readonly agreements: InputSignal<Array<Agreement>> = input<Array<Agreement>>([]);
  readonly newUser: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, {
    alias: 'newUser',
    transform: booleanAttribute
  });

  readonly activeTrader: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, {
    alias: 'activeTrader',
    transform: booleanAttribute
  });

  readonly superscriptRequired: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, {
    alias: 'superscriptRequired',
    transform: booleanAttribute
  });

  readonly hideHeaders: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, {
    alias: 'hideHeaders',
    transform: booleanAttribute
  });

  readonly alreadySigned: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, {
    alias: 'alreadySigned',
    transform: booleanAttribute
  });

  getTermsConditions(): Agreement {
    return this.agreements()
      .find((item: Agreement): boolean => ConsolidatedAgreementsListComponent.TERMS_CONDITION_TYPES.indexOf(item.agreementType) >= 0);
  }

  getExchangeAgreements(): Array<Agreement> {
    return this.agreements()
      .filter((item: Agreement): boolean =>  ConsolidatedAgreementsListComponent.TERMS_CONDITION_TYPES.indexOf(item.agreementType) < 0);
  }

  getStockLendingAgreement(): Agreement {
    return {
      agreementType: AgreementType.STOCK_LENDING,
      agreementStatus: AgreementStatus.ACCEPTED
    };
  }

  onAgreementSelected(agreement: Agreement): void {
    this.modalService.open(ConsolidatedAgreementsModalComponent, undefined, { agreement });
  }
}
